<template>
<div>
  <div class="dashboard" v-if="user.type == 'member'">
    <div class="row">
      <div class="col-md-12">
        <div class="col-md-9">
          <!-- Application buttons -->
          <div class="box info-box">
            <div class="box-header text-center">
              <h3 class="box-title"><i class="fa fa-info"></i> Short Keys</h3>
            </div>
            <div class="box-body text-center">
              <a class="btn btn-app box-widget box-red" @click="loansummery">
                <i class="fa fa-leanpub"></i> Loan Details
              </a>
              <a class="btn btn-app box-widget box-red" @click="collections">
                <i class="fa fa-money"></i> Paid EMI
              </a>
              <a class="btn btn-app box-widget box-red" @click="emis">
                <i class="fa fa-inr"></i> Due EMI
              </a>
              <a class="btn btn-app box-widget box-red" @click="emireceipt">
                <i class="fa fa-file-text"></i>EMI Receipt
              </a>
              <!-- <a class="btn btn-app box-widget box-red" @click="settlements">
                <i class="fa fa-archive"></i> Settlement
              </a> -->
            </div>
            <!-- /.box-body -->
          </div>
          <!-- /.box -->
        </div>
        <div class="col-md-3">
          <div class="box info-box">
          <center>
            <clock border="2px solid" color="white" bg="red" size="130px"></clock>
          </center>
          </div>
        </div>        
      </div>
      <div class="col-md-12">
        <membercollection></membercollection>
      </div>
    </div>
  </div>

  <div v-else class="dashboard">
    <div class="row">
      <div class="col-md-12">
        <div class="col-md-9">
          <!-- Application buttons -->
          <div class="box info-box">
            <div class="box-header text-center">
              <h3 class="box-title"><i class="fa fa-info"></i> Short Keys</h3>
            </div>
            <div class="box-body text-center">
              <a v-if="canAccess('member-create')" class="btn btn-app box-widget box-red" @click="users">
                <i class="fa fa-users"></i> Members
              </a>
              <a v-if="canAccess('loan-plan-create')" class="btn btn-app box-widget box-red" @click="plans">
                <i class="fa fa-plus"></i> Plan
              </a>
              <a v-if="canAccess('loan-disbursement-create-loan')" class="btn btn-app box-widget box-red" @click="individualloans">
                <i class="fa fa-credit-card"></i> Loan
              </a>
              <a v-if="canAccess('loan-disbursement-create-loan')" class="btn btn-app box-widget box-red" @click="grouploans">
                <i class="fa fa-credit-card-alt"></i> Group Loan
              </a>
              <a v-if="canAccess('member-loan-plan-view-any')" class="btn btn-app box-widget box-red" @click="loansummery">
                <i class="fa fa-leanpub"></i> Loan Details
              </a>
              <a v-if="canAccess('member-collection-view-any')" class="btn btn-app box-widget box-red" @click="collections">
                <i class="fa fa-money"></i> Collection
              </a>
              <a v-if="canAccess('member-emi-view')" class="btn btn-app box-widget box-red" @click="emis">
                <i class="fa fa-inr"></i> Collect EMI
              </a>
              <!-- <a class="btn btn-app">
                <i class="fa fa-check-square-o"></i> Check
              </a> -->
              <a v-if="canAccess('member-collection-view-any')" class="btn btn-app box-widget box-red" @click="emireceipt">
                <i class="fa fa-file-text"></i>EMI Receipt
              </a>
              <a v-if="canAccess('sattlement-create')" class="btn btn-app box-widget box-red" @click="settlements">
                <i class="fa fa-archive"></i> Settlement
              </a>
            </div>
            <!-- /.box-body -->
          </div>
          <!-- /.box -->
        </div>
        <div class="col-md-3">
          <div class="box info-box">
          <center>
            <clock border="2px solid" color="white" bg="red" size="130px"></clock>
          </center>
          </div>
        </div>
      </div>
      <balancerecord v-if="canAccess('staff-create')" :message="dashboardRecord"></balancerecord>  
      <!-- <totaloutstanding v-if="canAccess('member-loan-plan-view-any')" :message="dashboardRecord"></totaloutstanding> -->
      <totaloutstanding v-if="canAccess('staff-create')" :message="dashboardRecord"></totaloutstanding>
      <!-- <totalcollection :message="dashboardRecord"></totalcollection> -->
      <totalcollection v-if="canAccess('staff-create')" :message="dashboardRecord"></totalcollection>
      <interestbalance v-if="canAccess('staff-create')" :message="dashboardRecord"></interestbalance>
      
    </div>

      <div class="row" v-if="canAccess('staff-create')">
        <div class="col-md-3 col-xs-12">
          <!-- Widget: user widget style 1 -->
          <div class="box info-box box-widget widget-user">
            <!-- Add the bg color to the header using any of the bg-* classes -->
            <div class="widget-user-header box-green">
              <!-- /.widget-user-image -->
              <h3 class="widget-user-username">Collection</h3>
              <h5 class="widget-user-desc">Approved In Amount</h5>
              <h5 class="widget-user-desc">1234</h5>
            </div>
            <div class="box-footer no-padding">
              <ul class="nav nav-stacked">
                <li><a href="#">Today <span class="pull-right badge bg-blue" v-if="dashboardRecord[7]">{{dashboardRecord[7].collectionApprovedDaily}}</span></a></li>
                <li><a href="#">Weekly <span class="pull-right badge bg-aqua" v-if="dashboardRecord[8]">{{dashboardRecord[8].collectionApprovedWeekly}}</span></a></li>
                <li><a href="#">Monthly <span class="pull-right badge bg-green" v-if="dashboardRecord[9]">{{dashboardRecord[9].collectionApprovedMonthly}}</span></a></li>
                <li><a href="#">Total <span class="pull-right badge bg-red" v-if="dashboardRecord[10]">{{dashboardRecord[10].collectionApprovedTotal}}</span></a></li>
              </ul>
            </div>
          </div>
          <!-- /.widget-user -->
        
        </div>
        <div class="col-md-3 col-xs-12">
          <!-- Widget: user widget style 1 -->
          <div class="box box-widget widget-user">
            <!-- Add the bg color to the header using any of the bg-* classes -->
            <div class="widget-user-header box-red">
              
              <!-- /.widget-user-image -->
              <h3 class="widget-user-username">Collection</h3>
              <h5 class="widget-user-desc">Pending In Amount</h5>
            </div>
            <div class="box-footer no-padding">
              <ul class="nav nav-stacked">
                <li><a href="#">Today <span class="pull-right badge bg-blue" v-if="dashboardRecord[12]">{{dashboardRecord[12].collectionPendingDaily}}</span></a></li>
                <li><a href="#">Weekly <span class="pull-right badge bg-aqua" v-if="dashboardRecord[13]">{{dashboardRecord[13].collectionPendingWeekly}}</span></a></li>
                <li><a href="#">Monthly <span class="pull-right badge bg-warning" v-if="dashboardRecord[14]">{{dashboardRecord[14].collectionPendingMonthly}}</span></a></li>
                <li><a href="#">Total <span class="pull-right badge bg-red" v-if="dashboardRecord[15]">{{dashboardRecord[15].collectionPendingTotal}}</span></a></li>
              </ul>
            </div>
          </div>
          <!-- /.widget-user -->
        </div>
        <div class="col-md-3 col-xs-12">
          <!-- Widget: user widget style 1 -->
          <div class="box box-widget widget-user">
            <!-- Add the bg color to the header using any of the bg-* classes -->
            <div class="widget-user-header box-green">
              
              <!-- /.widget-user-image -->
              <h3 class="widget-user-username">Disbursement</h3>
              <h5 class="widget-user-desc">Approved In Amount</h5>
            </div>
            <div class="box-footer no-padding">
              <ul class="nav nav-stacked">
                <li><a href="#">Today <span class="pull-right badge bg-blue" v-if="dashboardRecord[17]">{{dashboardRecord[17].disbursmentApprovedDaily}}</span></a></li>
                <li><a href="#">Weekly <span class="pull-right badge bg-aqua" v-if="dashboardRecord[18]">{{dashboardRecord[18].disbursmentApprovedWeekly}}</span></a></li>
                <li><a href="#">Monthly <span class="pull-right badge bg-green" v-if="dashboardRecord[19]">{{dashboardRecord[19].disbursmentApprovedMonthly}}</span></a></li>
                <li><a href="#">Total <span class="pull-right badge bg-red" v-if="dashboardRecord[20]">{{dashboardRecord[20].disbursmentApprovedTotal}}</span></a></li>
              </ul>
            </div>
          </div>
          <!-- /.widget-user -->
        
        </div>
        <div class="col-md-3 col-xs-12">
          
          <!-- Widget: user widget style 1 -->
          <div class="box box-widget widget-user">
            <!-- Add the bg color to the header using any of the bg-* classes -->
            <div class="widget-user-header box-red">
              
              <!-- /.widget-user-image -->
              <h3 class="widget-user-username">Disbursement</h3>
              <h5 class="widget-user-desc">Pending Number Of Loans</h5>
            </div>
            <div class="box-footer no-padding">
              <ul class="nav nav-stacked">
                <li><a href="#">Today <span class="pull-right badge bg-blue" v-if="dashboardRecord[22]">{{dashboardRecord[22].disbursmentPendingDailyRows}}</span></a></li>
                <li><a href="#">Weekly <span class="pull-right badge bg-aqua" v-if="dashboardRecord[23]">{{dashboardRecord[23].disbursmentPendingWeeklyRows}}</span></a></li>
                <li><a href="#">Monthly <span class="pull-right badge bg-green" v-if="dashboardRecord[24]">{{dashboardRecord[24].disbursmentPendingMonthlyRows}}</span></a></li>
                <li><a href="#">Total <span class="pull-right badge bg-red" v-if="dashboardRecord[25]">{{dashboardRecord[25].disbursmentPendingTotalRows}}</span></a></li>
              </ul>
            </div>
          </div>
          <!-- /.widget-user -->
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <!-- <barChart></barChart> -->
          <pendingrecords></pendingrecords>
          <membercollection></membercollection>
            <!-- /.box -->
          <recentdisbursment v-if="canAccess('disbursment-view-any')"></recentdisbursment>
            <!-- /.box -->
          
            <!-- /.box -->
          <!-- <recentlogactivity v-if="canAccess('log-activity-view-any')"></recentlogactivity> -->
            <!-- /.box -->
        </div>
        <div class="col-md-6">
          <recentmember></recentmember>
          <!-- <div class="box box-primary">
            <div class="box-body no-padding">
              <FullCalendar :options="calendarOptions" />
            </div>
          </div> -->
          <!-- Custom tabs (Charts with tabs)-->
          <!-- <div class="box box-default">
            <div class="box-header with-border">
                <h3 class="box-title">Growth Chart</h3>
            </div>
            <div class="box-body">
                <piechart></piechart>
            </div>
          </div> -->
            <!-- /.box -->
        </div>
      </div>
        
  </div>
</div>
</template>

<script>
// var Chart = require('chart.js')
import VASmallBox from '../widgets/VASmallBox.vue'
import Clock from 'vue-clock2'
// import PlanetChart from '../dashboard/PlanetChart.vue'
// import FullCalendar from '@fullcalendar/vue'
// import dayGridPlugin from '@fullcalendar/daygrid'
// import interactionPlugin from '@fullcalendar/interaction'
// import timeGridPlugin from '@fullcalendar/timegrid'
// import VueWeather from 'vue-weather-widget'
import pendingrecords from '../dashboard/PendingManagement.vue'
import membercollection from '../dashboard/recentcollection.vue'
import recentdisbursment from '../dashboard/recentdisbursment.vue'
import recentmember from '../dashboard/recentmember.vue'
// import recentlogactivity from '../dashboard/logactivity.vue'
import balancerecord from '../dashboard/balancerecord.vue'
import totalcollection from '../dashboard/totalcollection.vue'
import totaloutstanding from '../dashboard/totaloutstanding.vue'
import interestbalance from '../dashboard/interestbalance.vue'
// import barChart from '../dashboard/barchart.vue'
// import piechart from '../dashboard/piechart.vue'
export default {
  name: 'dashboard',
  data () {
    return {
      user: JSON.parse(localStorage.user),
      dashboardRecord: [],
      branch: {},
      // calendarOptions: {
        // plugins: [ dayGridPlugin, timeGridPlugin, interactionPlugin ],
        // headerToolbar: {
        //   left: 'prev,next today',
        //   center: 'title',
        //   right: 'dayGridMonth,timeGridWeek,timeGridDay'
        // },
        // initialView: 'dayGridMonth',
        // initialEvents: INITIAL_EVENTS, // alternatively, use the `events` setting to fetch from a feed
        // editable: true,
        // selectable: true,
        // selectMirror: true,
        // dayMaxEvents: true,
        // weekends: true,
        // select: this.handleDateSelect,
        // eventClick: this.handleEventClick,
        // eventsSet: this.handleEvents,
        /* you can update a remote database when these fire:
        eventAdd:
        eventChange:
        eventRemove:
        */
        // dateClick: this.handleDateClick,
        // currentEvents: [],
        // events: [
        //   { title: 'event 1', date: '2019-04-01' },
        //   { title: 'event 2', date: '2019-04-02' }
        // ]
      // },
      labels: ['apples', 'bananas', 'grapes'],
      datasets: [
        {
          data: [20, 30, 50],
          backgroundColor: ['red', 'yellow', 'green']
        }
      ],
      options: {
        title: {
          display: true,
          position: 'bottom',
          text: 'Fruits'
        }
      },
      noOfMem: '',
      noOfSta: 0,
      noOfCustomer: 0,
      noOfStaf: 0,
      totalAmount: 0,
      totalCollection: 0,
      calculatorEmi: [],
      totalAmt: [],
      calculatorData: {},
      columnsCollectionCenter: [
        {
          label: 'GROUP CODE',
          field: 'centerCode'
        },
        {
          label: 'GROUP NAME',
          field: 'name'
        },
        {
          label: 'BRANCH',
          field: 'branch.name'
        },

        {
          label: 'STATUS',
          field: 'Status'
        }
      ],
      rowsCollectionCenter: [],
      TableColumn: [
        { label: 'Date', field: 'date' },
        { label: 'Base', field: 'principal' },
        { label: 'Intrest', field: 'interest' },
        { label: 'EMI', field: 'emi' },
        { label: 'Balance', field: 'balance' }
      ]
    }
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    users () {
      this.$router.push({name: 'customer'})
    },
    plans () {
      this.$router.push({name: 'loanplan'})
    },
    individualloans () {
      this.$router.push({name: 'individualLoan'})
    },
    grouploans () {
      this.$router.push({name: 'groupLoan'})
    },
    loansummery () {
      this.$router.push({name: 'loanSummary'})
    },
    collections () {
      this.$router.push({name: 'showCollection'})
    },
    emis () {
      this.$router.push({name: 'emiCollection'})
    },
    emireceipt () {
      this.$router.push({name: 'showCollection'})
    },
    settlements () {
      this.$router.push({name: 'settlement'})
    },
    handleWeekendsToggle () {
      this.calendarOptions.weekends = !this.calendarOptions.weekends // update a property
    },
    handleDateSelect (selectInfo) {
      let title = prompt('Please enter a new title for your event')
      let calendarApi = selectInfo.view.calendar
      calendarApi.unselect() // clear date selection
      if (title) {
        calendarApi.addEvent({
          id: createEventId(),
          title,
          start: selectInfo.startStr,
          end: selectInfo.endStr,
          allDay: selectInfo.allDay
        })
      }
    },
    handleEventClick (clickInfo) {
      if (confirm(`Are you sure you want to delete the event '${clickInfo.event.title}'`)) {
        clickInfo.event.remove()
      }
    },
    handleEvents (events) {
      this.currentEvents = events
    },

    handleDateClick: function (arg) {
      alert('date click! ' + arg.dateStr)
    },
    loadData () {
      // var c = JSON.parse(localStorage.user)
      // var pageUrl = ''
      // pageUrl += 'dashboard'
      var c = JSON.parse(localStorage.user)
      if (c.type === 'staff') {
        this.branch.id = c.agent_profile.branch_id
      }
      var pageUrl = ''
      pageUrl += 'dashboard?all=all'
      if (this.branch.id) {
        pageUrl += `&branch_id=${this.branch.id}`
      }
      this.$axios
        .get(pageUrl, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.dashboardRecord = data.dashboard
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    loadSunday () {
      this.$axios
        .get('leavetype/sunday', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.rows1 = data
          _.forEach(this.rows1, function (value) {
            const dateString = value.replace('Sunday ', '')
            const changedDate = dateString.replace(/(..)\/(..)\/(....) (..):(..)/, '$3-$2-$1 $4:$5')
            var date = new Date(changedDate)

            var dd = date.getFullYear() + '-' + ('0' + parseInt(date.getMonth() + 1)).slice(-2) + '-' + ('0' + (date.getDate())).slice(-2)

            this.calendarOptions.events.push({ title: 'Sunday', date: dd, allDay: true })
          }.bind(this))
        })
        .catch(
          function (error) {
            let er = error.response.data.message
            Toast.fire({ icon: 'error', title: er })
          }
        )
    }
  },
  created () {
    // this.loadSunday()
    this.loadData()
  },
  // watch: {
  //   userPermission (newd, old) {
  //     if (!newd.some(data => data.id === 1)) {
  //       this.$router.push({'path': '/Error403'})
  //     }
  //   }
  // },
  computed: {
    userPermission () {
      return this.$store.state.permissions
    }
  },
  components: {
    'va-small-box': VASmallBox,
    'clock': Clock,
    // FullCalendar,
    // VueWeather,
    membercollection,
    // PlanetChart,
    pendingrecords,
    recentdisbursment,
    recentmember,
    // recentlogactivity,
    balancerecord,
    totalcollection,
    totaloutstanding,
    interestbalance
    // barChart
    // piechart
  }
}

</script>
<style scoped>
  table.v-table thead th {
      font-size: 20px;
 }
 .widget-user .widget-user-header {
    height: 70px;
 }
 .box-widget {
   border-radius:10px;
   box-shadow: 0px 0px 4px gray;
 }
 .widget-user-desc-b {
   padding-bottom: 10px;
 }
 .box-red {
    background-color:#ec1c22;
    color: #fff;
  }
  /* .box-green {
    background-color: #0e8c0e;
    color: #fff;
  }
  .box-info {
    background-color: #2389c4;
    color: #fff;
  }
  .box-warning {
    background-color: #f0c128;
    color: #fff;
  } */
  h5 {
    padding-bottom: 10px;
    margin-bottom: 10px;
  }
  .widget-user .widget-user-header {
    height: 85px;
  }
  .info-box {
    border-radius:10px;
    box-shadow: 0px 0px 4px gray;
  }
</style>




// WEBPACK FOOTER //
// Dashboard.v1.vue?c8c49b02